// Scheme allowlist for any URL that originates from user-generated content
// (e.g. a post author's "web" link). Such a link is fully attacker-controlled
// and is later rendered as an <iframe src> / opened in a new tab, so we must
// confine it to plain web schemes. This blocks javascript:, data:, file:,
// blob:, intent:, vbscript: and any custom app deep-link from ever reaching a
// DOM sink. Mirrors the Flutter app's _isWebUrl guard.
export function isHttpUrl(value: unknown): boolean {
	if (typeof value !== 'string') return false;
	const trimmed = value.trim();
	if (!trimmed) return false;
	try {
		const u = new URL(trimmed);
		return u.protocol === 'http:' || u.protocol === 'https:';
	} catch {
		return false;
	}
}

// Returns the URL only if it is a safe http(s) link, otherwise null. Handy for
// "render the embed only when the link is safe" call sites.
export function safeHttpUrl(value: unknown): string | null {
	return isHttpUrl(value) ? (value as string).trim() : null;
}
